//Action for Contact Person Search with Company's id List returned

import {
  CONTACT_PERSON_SINGLE_COMPANY_SEARCH,
  CONTACT_PERSON_SINGLE_COMPANY_SEARCH_SUCCESS,
  CONTACT_PERSON_SINGLE_COMPANY_SEARCH_FAILURE,
  CREATE_CONTACT_PERSON,
  CREATE_CONTACT_PERSON_SUCCESS,
  CREATE_CONTACT_PERSON_FAILURE,
  GET_SINGLE_PERSON_CONTACT_DETAILS,
  GET_SINGLE_PERSON_CONTACT_DETAILS_SUCCESS,
  GET_SINGLE_PERSON_CONTACT_DETAILS_FAILURE,
  DELETE_CONTACT_PERSON,
  DELETE_CONTACT_PERSON_SUCCESS,
  DELETE_CONTACT_PERSON_FAILURE,
  UPDATE_CONTACT_PERSON,
  UPDATE_CONTACT_PERSON_SUCCESS,
  UPDATE_CONTACT_PERSON_FAILURE,
  DELETE_CONTACT_PERSON_RELATIONSHIP,
  DELETE_CONTACT_PERSON_RELATIONSHIP_SUCCESS,
  DELETE_CONTACT_PERSON_RELATIONSHIP_FAILURE,
  CONTACT_PERSON_TO_EMAIL_INBOUND_SEARCH,
  CONTACT_PERSON_TO_EMAIL_INBOUND_SEARCH_SUCCESS,
  CONTACT_PERSON_TO_EMAIL_INBOUND_SEARCH_FAILURE,
  CONTACT_PERSON_TO_EMAIL_INBOUND_DATA,
  CONTACT_PERSON_TO_EMAIL_INBOUND_DATA_SUCCESS,
  CONTACT_PERSON_TO_EMAIL_INBOUND_DATA_FAILURE,
  CONTACT_PERSON_DATA,
  CONTACT_PERSON_DATA_SUCCESS,
  CONTACT_PERSON_DATA_FAILURE,
  CONTACT_PERSON_LIST,
  CONTACT_PERSON_LIST_SUCCESS,
  CONTACT_PERSON_LIST_FAILURE,
  SEARCH_PERSON_WITH_CUSTOMER_ID,
  SEARCH_PERSON_WITH_CUSTOMER_ID_SUCCESS,
  SEARCH_PERSON_WITH_CUSTOMER_ID_FAILURE,
  CUSTOMER_TO_CONTACT_PERSON_RELATIONSHIP_SEARCH,
  CUSTOMER_TO_CONTACT_PERSON_RELATIONSHIP_SEARCH_SUCCESS,
  CUSTOMER_TO_CONTACT_PERSON_RELATIONSHIP_SEARCH_FAILURE,
} from "./actionType";

// Action for Contact Person Search with Company's id List returned
export const contactPersonSingleCompanySearch = (id) => {
  return {
    type: CONTACT_PERSON_SINGLE_COMPANY_SEARCH,
    id,
  };
};

export const contactPersonSingleCompanySearchSuccess = (data) => {
  return {
    type: CONTACT_PERSON_SINGLE_COMPANY_SEARCH_SUCCESS,
    data,
  };
};

export const contactPersonSingleCompanySearchFailure = (error) => {
  return {
    type: CONTACT_PERSON_SINGLE_COMPANY_SEARCH_FAILURE,
    error,
  };
};

// Action for Create Contact Person

export const createContactPerson = (data) => {
  return {
    type: CREATE_CONTACT_PERSON,
    data,
  };
};

export const createContactPersonSuccess = (data) => {
  return {
    type: CREATE_CONTACT_PERSON_SUCCESS,
    data,
  };
};

export const createContactPersonFailure = (error) => {
  return {
    type: CREATE_CONTACT_PERSON_FAILURE,
    error,
  };
};

// Get Single Person Contact Details
export const getSinglePersonContactDetails = (id) => {
  return {
    type: GET_SINGLE_PERSON_CONTACT_DETAILS,
    id,
  };
};

export const getSinglePersonContactDetailsSuccess = (data) => {
  return {
    type: GET_SINGLE_PERSON_CONTACT_DETAILS_SUCCESS,
    data,
  };
};

export const getSinglePersonContactDetailsFailure = (error) => {
  return {
    type: GET_SINGLE_PERSON_CONTACT_DETAILS_FAILURE,
    error,
  };
};

// Delete Contact Person

export const deleteContactPerson = (id) => {
  return {
    type: DELETE_CONTACT_PERSON,
    id,
  };
};

export const deleteContactPersonSuccess = (data) => {
  return {
    type: DELETE_CONTACT_PERSON_SUCCESS,
    data,
  };
};

export const deleteContactPersonFailure = (error) => {
  return {
    type: DELETE_CONTACT_PERSON_FAILURE,
    error,
  };
};

// Update Contact Person

export const updateContactPerson = (data) => {
  return {
    type: UPDATE_CONTACT_PERSON,
    data,
  };
};

export const updateContactPersonSuccess = (data) => {
  return {
    type: UPDATE_CONTACT_PERSON_SUCCESS,
    data,
  };
};

export const updateContactPersonFailure = (error) => {
  return {
    type: UPDATE_CONTACT_PERSON_FAILURE,
    error,
  };
};

// Delete Contact Person Relationship

export const deleteContactPersonRelationship = (id) => {
  return {
    type: DELETE_CONTACT_PERSON_RELATIONSHIP,
    id,
  };
};

export const deleteContactPersonRelationshipSuccess = (data) => {
  return {
    type: DELETE_CONTACT_PERSON_RELATIONSHIP_SUCCESS,
    data,
  };
};

export const deleteContactPersonRelationshipFailure = (error) => {
  return {
    type: DELETE_CONTACT_PERSON_RELATIONSHIP_FAILURE,
    error,
  };
};

// Action for Contact Person Search with Company's id List returned
export const contactPersonToEmailInboundSearch = (id) => {
  return {
    type: CONTACT_PERSON_TO_EMAIL_INBOUND_SEARCH,
    payload: id,
  };
};

export const contactPersonToEmailInboundSearchSuccess = (payload) => {
  return {
    type: CONTACT_PERSON_TO_EMAIL_INBOUND_SEARCH_SUCCESS,
    payload,
  };
};

export const contactPersonToEmailInboundSearchFailure = (payload) => {
  return {
    type: CONTACT_PERSON_TO_EMAIL_INBOUND_SEARCH_FAILURE,
    payload,
  };
};

// Action for Contact Person Search with Company's id List returned
export const contactPersonToEmailInboundData = (id) => {
  return {
    type: CONTACT_PERSON_TO_EMAIL_INBOUND_DATA,
    payload: id,
  };
};

export const contactPersonToEmailInboundDataSuccess = (payload) => {
  return {
    type: CONTACT_PERSON_TO_EMAIL_INBOUND_DATA_SUCCESS,
    payload,
  };
};

export const contactPersonToEmailInboundDataFailure = (payload) => {
  return {
    type: CONTACT_PERSON_TO_EMAIL_INBOUND_DATA_FAILURE,
    payload,
  };
};

// Action for Contact Person Search with Company's id List returned
export const contactPersonData = (id) => {
  return {
    type: CONTACT_PERSON_DATA,
    payload: id,
  };
};

export const contactPersonDataSuccess = (payload) => {
  return {
    type: CONTACT_PERSON_DATA_SUCCESS,
    payload,
  };
};

export const contactPersonDataFailure = (payload) => {
  return {
    type: CONTACT_PERSON_DATA_FAILURE,
    payload,
  };
};

// Action for Contact Person Search with Company's id List returned
export const contactPersonList = () => {
  return {
    type: CONTACT_PERSON_LIST,
  };
};

export const contactPersonListSuccess = (payload) => {
  return {
    type: CONTACT_PERSON_LIST_SUCCESS,
    payload,
  };
};

export const contactPersonListFailure = (payload) => {
  return {
    type: CONTACT_PERSON_LIST_FAILURE,
    payload,
  };
};

// Action for Contact Person Search with Company's id List returned
export const searchPersonWithCustomerId = (id) => {
  return {
    type: SEARCH_PERSON_WITH_CUSTOMER_ID,
    payload: id,
  };
};

export const searchPersonWithCustomerIdSuccess = (payload) => {
  return {
    type: SEARCH_PERSON_WITH_CUSTOMER_ID_SUCCESS,
    payload,
  };
};

export const searchPersonWithCustomerIdFailure = (payload) => {
  return {
    type: SEARCH_PERSON_WITH_CUSTOMER_ID_FAILURE,
    payload,
  };
};

// Action for Contact Person Search with Company's id List returned
export const customerToContactPersonRelationshipSearch = (id) => {
  return {
    type: CUSTOMER_TO_CONTACT_PERSON_RELATIONSHIP_SEARCH,
    payload: id,
  };
};

export const customerToContactPersonRelationshipSearchSuccess = (payload) => {
  return {
    type: CUSTOMER_TO_CONTACT_PERSON_RELATIONSHIP_SEARCH_SUCCESS,
    payload,
  };
};

export const customerToContactPersonRelationshipSearchFailure = (payload) => {
  return {
    type: CUSTOMER_TO_CONTACT_PERSON_RELATIONSHIP_SEARCH_FAILURE,
    payload,
  };
};
